import styles from "./Delimiter.module.scss";

const Delimiter = () => <div className={styles.delimiter} />;

export default Delimiter;
